import {baseApi} from './baseApi';

export const injectedContractApi = baseApi.injectEndpoints({
    addTagTypes: ['Contract'],
    endpoints: (builder) => ({
        getContract: builder.query({
            query: (args) => {
                const {projectId, flurstueckId} = args;

                let url = `getContract?project_id=${projectId}&flurstueck_id=${flurstueckId}`;

                return {url: url};
            },
            providesTags: ['Contract']
        }),
        getProjectContractTypes: builder.query({
            query: (args) => {
                let url = `getProjectContractTypes`;

                return {url: url};
            },
            providesTags: ['Contract']
        }),
        refetchErroredQueries: builder.mutation({
            queryFn: () => ({data: null}),
            invalidatesTags: ['UNKNOWN_ERROR'],
        }),
        createContract: builder.mutation({
            query: (data) => ({
                url: 'createContract',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Contract']
        }),
        updateContract: builder.mutation({
            query: (data) => ({
                url: 'updateContract',
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Contract']
        }),
        deleteContract: builder.mutation({
            query: (data) => ({
                url: 'deleteContract',
                method: 'DELETE',
                body: data,
            }),
            invalidatesTags: ['Contract']
        }),
    }),
});

export const {
    useGetContractQuery,
    useGetProjectContractTypesQuery,
    useCreateContractMutation,
    useUpdateContractMutation,
    useDeleteContractMutation,
} = injectedContractApi;
